import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IPromotionProductListRequest } from '../models/models'

export class GetPromotionProductListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/GetPromotionProductList',
      requesterInfo,
    })
  }

  public async getPromotionProductList(request: IPromotionProductListRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
